import $ from 'jquery';

/**
 * Session check ping
 */
const ping = () => {
	if ($('.navbar-user').length) {
		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/profile/ping',
		})
			.fail(function (response) {
				/* eslint-disable eqeqeq */
				if (response.status == 401) {
					window.location.href = '/';
				} else if (response.status == 419) {
					$('#page-expired-modal').modal('show');
				} else if (response.status == 503) {
					$('#maintenance-modal').modal('show');
				}
				/* eslint-enable eqeqeq */
			})
			.complete(function () {
				if ($('#maintenance-modal').hasClass('in')) {
					$('#maintenance-modal').modal('hide');
				}
			});
	}
};

const initPing = () => {
	window.setInterval(ping, 1000 * 60 * 2); // Every 2 minutes

	document.addEventListener('visibilitychange', function () {
		// Every time the content of the tab becomes visible
		if (document.visibilityState === 'visible') {
			ping();
		}
	});
};

export { ping, initPing };
